import {LOAD_CRUCESINTERNACIONALES_SUCCESS, ICruceInternacional, CruceInternacionalActionTypes} from "../types/cruceInternacionalActionTypes";


export default function cruceInternacionalReducer(state = [], action: CruceInternacionalActionTypes): ICruceInternacional[] {
    switch (action.type) {
        case LOAD_CRUCESINTERNACIONALES_SUCCESS:
            return action.crucesInternacionales;
        default:
            return state;
    }
}

